import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import IndexRepository from "../Repositories/IndexRepository";

class IndexBloc {
  workUnitChannel = new Subject();
  empChannel = new Subject();
  exportChannel = new Subject();
  repository = new IndexRepository();

  constructor() {
    this.workUnitChannel.next({ status: apiResponse.INITIAL });
    this.empChannel.next({ status: apiResponse.INITIAL });
    this.exportChannel.next({ status: apiResponse.INITIAL });
  }

  fetchWorkUnit = async (query) => {
    try {
      this.workUnitChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchWorkUnit(query)
        .then((result) => {
          this.workUnitChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.workUnitChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) { }
  };

  fetchExport_WFH = async (query) => {
    try {
      this.exportChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchExport_WFH(query)
        .then((result) => {
          this.exportChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.exportChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) { }
  };

}

export default IndexBloc;
